import React, { ChangeEvent, useState } from 'react';
import ITagDetail from '@Shared.Angular/@types/core/contracts/queryModel/tagGroup/tagDetail';
import { Box } from '@mui/material';
import Chip from '@Shared.Angular/flowingly.components/Chip/Chip';

type Props = {
  tags: ITagDetail[];
  color: string;
  onAddTag: (tag: ITagDetail) => void;
  onRemoveTag: (id: string) => void;
  onRemoveAllTags: () => void;
  onUpdateTag: (updatedTag: ITagDetail) => void;
};

const TagSelector: React.FC<Props> = ({
  tags,
  color,
  onAddTag,
  onRemoveTag,
  onRemoveAllTags,
  onUpdateTag
}) => {
  const [tagInput, setTagInput] = useState('');

  const handleTagInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setTagInput(event.target.value);
  };

  const handleTagKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && tagInput.trim()) {
      event.preventDefault();
      const newTag = { name: tagInput.trim() };
      if (
        !tags.some(
          (tag) => tag.name.toLowerCase() === newTag.name.toLowerCase()
        )
      ) {
        onAddTag(newTag);
      }
      setTagInput('');
    }
  };

  return (
    <div className="tag-list-outer-container">
      <div className="tag-list-container">
        {tags.map((tag) => (
          <Chip
            key={tag.name}
            id={tag.id}
            name={tag.name}
            color={color}
            onRemoveChip={onRemoveTag}
            canRemove={true}
            canEdit={true}
            onUpdateChip={onUpdateTag}
          />
        ))}
        <div className="tag-input-wrapper">
          <i className="fa-plus"></i>
          <input
            type="text"
            value={tagInput}
            onChange={handleTagInputChange}
            onKeyDown={handleTagKeyDown}
            placeholder="Type and press Enter"
          />
        </div>
      </div>
      <Box display={'flex'} justifyContent={'flex-end'} paddingTop={'10px'}>
        {tags.length > 0 && (
          <button className="remove-all" onClick={onRemoveAllTags}>
            Remove All
          </button>
        )}
      </Box>
    </div>
  );
};

export default TagSelector;
